import type { ReactNode } from 'react';
import { Alert, Box, Title, Text } from '@mantine/core';

export function EmptyState({
  title,
  description,
  action,
  testId,
}: {
  title: string;
  description: string;
  action?: ReactNode;
  testId?: string;
}) {
  return (
    <Alert color="gray" variant="light" radius="lg" data-testid={testId}>
      <Title order={3} size="h4">{title}</Title>
      <Text c="dimmed" mt={4}>{description}</Text>
      {action ? <Box mt="md">{action}</Box> : null}
    </Alert>
  );
}
